module.exports = __webpack_public_path__ + "img/vue-text-to-speech.e22cbd14.png";